module.exports = __webpack_public_path__ + "media/images/icon_arrow_sp_up-db57fc2179a91ce7a98aec6bef94ec96.png";